import { RootState } from "../../store/types";
import { AsyncEntity } from "../_shared/action-model-async";
import { ClientSettings } from "../../api";

const adviseTenantId = 53;

export const getSiteSettings = (state: RootState): AsyncEntity<ClientSettings> => state.tenant.current;
export const getBranding = (state: RootState): boolean => getSiteSettings(state).entity?.tenantId === adviseTenantId;